module.exports = __webpack_public_path__ + "assets/img/experience-4.31e6c438.svg";